import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import CustomPriceSpan from "../../../../components/CustomPriceSpan";
import { Tooltip as ReactTooltip } from "react-tooltip";
import * as dashboardSelectors from "../../../../selectors/dashboard";
import {
  getUserAccountBodyType,
  getUserClientBranchCode, getUserClientBranchName, getUserClientClientCode, getUserClientClientName,
  getUserClientCode,
  getUserClientFullCDSNumber, getUserClientRemisierCode, getUserClientRemisierName,
  getUserName
} from "../../../../selectors/user";
import * as userSelelectors from "../../../../selectors/user";

function ClientInfo({item,isDashboard=false}){
  const clientCode = userSelelectors.getUserClientClientCode(item);
  const clientName = userSelelectors.getUserClientClientName(item);
  const clientAccountBodyType = userSelelectors.getUserAccountBodyType(item);
  const fullCds = userSelelectors.getUserClientFullCDSNumber(item);
  const clientBranchCode = userSelelectors.getUserClientBranchCode(item);
  const clientBranchName = userSelelectors.getUserClientBranchName(item);
  const remisierCode = userSelelectors.getUserClientRemisierCode(item);
  const remisierName = userSelelectors.getUserClientRemisierName(item);
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  return <div className="container-fluid">

    {isDashboard ? <div
        className={clsx(
            "d-flex justify-content-center align-items-center ",
        )}
    >
      <h4 className=" mb-0 mt-4 text-bold-600 black-text text-center">
        Welcome {clientName}
      </h4>
    </div> : false}

    <div className="mt-3">
      <div className={clsx("custom-card-content-container float-header")}>
        <Row>
          <Col md={6} lg={3} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>{clientCode} ({clientAccountBodyType})</h4>
              <span className={clsx("text-bold-600")} style={{ fontSize: '17px'}}>{clientName}</span>
            </div>
          </Col>
          <Col md={6} lg={3} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Branch</h4>
              <span className={clsx("text-bold-600")}
                    style={{fontSize: '17px'}}>{clientBranchCode} - {clientBranchName}</span>
            </div>
          </Col>
          <Col md={6} lg={3} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>CDS Number</h4>
              <span className={clsx("text-bold-600")} style={{fontSize: '17px'}}>{fullCds}</span>
            </div>
          </Col>
          <Col md={6} lg={3} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Dealer</h4>
              <span className={clsx("text-bold-600")} style={{fontSize: '17px'}}>{remisierCode} / {remisierName}</span>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    {isDashboard ? false : <div className="mb-4"></div>}

  </div>

}

export default ClientInfo;